import React, { FC, useEffect, useRef, useState } from 'react';
import { appStore } from '@store';
import { METRICS } from '@types';
import styled from 'styled-components';
import { useT } from '@hooks';

interface Props {
	children: string;
	align?: string;
}

interface propsContainer {
	align?: string;
}

const Container = styled.p<propsContainer>`
	color: ${({ theme }) => theme.colors.text1};
	font-size: 17px;
	line-height: 22px;
	margin-top: 20px;

	span {
		color: ${({ theme }) => theme.colors.text14};
		font-weight: 700;
		${props =>
			props.align &&
			`
      display: flex;
      justify-content: center;
      margin-top: 16px;
      text-align: center;
      width: 100%;
    `}
	}
`;

export const Subtitle: FC<Props> = props => {
	const { children, align } = props;
	const { surveyStore, unitsStore } = appStore;
	const { answers } = surveyStore;
	const units = unitsStore.isMetrics ? METRICS.KG : METRICS.LBS;
	const [goalWeight, setGoalWeight] = useState<number>(0);
	const [curentWeight, setCurentWeight] = useState<number>(0);
	const ref = useRef<HTMLParagraphElement>(null);
	const { T } = useT();

	useEffect(() => {
		if (answers.target_weight?.[0]) {
			setGoalWeight(Number(JSON.parse(answers.target_weight?.[0]).value));
		}
		if (answers.weight?.[0]) {
			setCurentWeight(Number(JSON.parse(answers.weight?.[0]).value));
		}
	}, []);

	useEffect(() => {
		if (goalWeight && ref.current) {
			const bElement = ref.current.querySelector('b');

			if (bElement) {
				if (children === T('payment_text_6_1')) {
					bElement.innerHTML = `${curentWeight - goalWeight} ${units}&nbsp;`;
				} else {
					bElement.innerHTML = `${goalWeight} ${units}&nbsp;`;
				}
			}
		}
	}, [goalWeight, ref.current]);

	return (
		<Container ref={ref} align={align} dangerouslySetInnerHTML={{ __html: children }}></Container>
	);
};
